/**
 * Curated everyday Turkish lexicon shared by arcade games. WORDS stays the 3–6-letter Kaçış list;
 * YILAN_WORDS adds a small, studio-curated long-word layer. No external dictionary is bundled.
 */

/** Turkish uppercase: i → İ, ı → I (JS default would map i → I). */
export function trUpper(s: string): string {
  let out = "";
  for (const ch of s) out += ch === "i" ? "İ" : ch === "ı" ? "I" : ch.toUpperCase();
  return out;
}

/** Turkish lowercase: İ → i, I → ı. */
export function trLower(s: string): string {
  let out = "";
  for (const ch of s) out += ch === "İ" ? "i" : ch === "I" ? "ı" : ch.toLowerCase();
  return out;
}

export const TR_ALPHABET = "ABCÇDEFGĞHIİJKLMNOÖPRSŞTUÜVYZ";

const RAW = `
ada arı ayı baş bal bez boy buz dal dağ dil diz dut fil göl göz gül gün hat kaz kar kaş kek kız kol kum kuş kül
mum nar nem oda ova pil pul saç sal ses sis sol sağ son süt taş tel tat tuz top yağ yan yay yem yer yıl yol yaz
yün yüz zar zil çay çam bağ boş çöl dam

akıl alın anne arpa avuç ayak ayna ağaç ayva baba baca bere bina cami çatı çift çivi dede dere dost doğa elma
erik evet fare gece gemi gıda hava hece ilaç ipek isim ışık kafa kalp kapı kale kare kasa kaya kedi kese kira
kule kurt kutu kuyu lale masa mavi mera mide mola nane nota oğul ocak orta otel oyun örtü park saat soba soru
sarı tepe tren turp uçak uyku vazo veda yaka yara yeni yuva zeka zarf resim mısra süre şaka şiir şifa sucuk

araba bahçe bakır balık beyaz bulut cadde çanta çiçek dalga deniz dolap duvar ekmek fırın hayat hızlı irmak
kalem kalın kapak kemik kitap koyun lamba limon meyve mısır nehir nokta ördek pamuk pazar roman sahil salça
sepet sınıf sokak şarkı şeker tabak tarla tavuk tilki tuğla yürek zafer zaman zemin kaşık kayık kemer çorap
çocuk elbise kazak yemek kahve çorba balon bahar ceket çatal çelik dünya güneş kuzey orman çimen demir hayal
huzur kağıt köprü lokum melek merak motor müzik ödül öğle radyo saksı sebze silgi sinek sıcak soğuk sofra tatlı
tebrik türkü umut yarın büyük çakıl çanak çilek dergi dişçi duygu ejder elmas fırça fidan hamur pilot rakam
robot sabah saygı sevgi tarih tavan temiz vapur yarış yolcu zebra zihin bebek bilgi tohum

balkon bardak buğday cüzdan defter doktor enerji gazete gezgin gözlük harita heykel hediye hikaye ışıltı
kamera kaplan karpuz kasaba kumsal makine maymun mektup mercan mevsim mutfak otobüs parmak rehber rüzgar
sandık sinema tabela takvim tavşan tırnak trafik uçurum uyanık yağmur yastık yelken yıldız zeytin zürafa
balina
`;

/** Lowercase, deduplicated, 3–6 letters (the raw list also holds a few longer words that get filtered). */
const LOWER = Array.from(new Set(RAW.split(/\s+/).filter(Boolean))).filter((w) => {
  const n = Array.from(w).length;
  return n >= 3 && n <= 6;
});

export const WORDS: readonly string[] = LOWER.map(trUpper);

/** Words by length (3..6), in list order. */
export function wordsOfLength(n: number): string[] {
  return WORDS.filter((w) => Array.from(w).length === n);
}

export function letters(word: string): string[] {
  return Array.from(word);
}

/** Hand-curated longer everyday words for Harf Yılanı; lowercase natural spelling, no proper names. */
const YILAN_LONG_RAW = `
akvaryum alışveriş anahtar bakkaliye bilgisayar buzdolabı çalışkan çamaşır çikolata çizelge daktilo
denizatı dondurma düşünce fıstıklı fotoğraf gökkuşağı gülümse güzellik hatıralar hayvanlar ıspanak
ışıldamak kablolu kahvaltı kalabalık kediotu kirazlı kütüphane labirent limonata manzara matematik
mutluluk oyuncak papatya pencere portakal renkler saatler salatalık sandalye sebzeler sürpriz
televizyon topluluk uçurtma yabanmersini yakınlık yolculuk zeytinyağı özgürlük
`;

export const YILAN_WORDS: readonly string[] = Array.from(
  new Set([...WORDS, ...YILAN_LONG_RAW.split(/\s+/).filter(Boolean).map(trUpper)]),
).filter((word) => {
  const chars = Array.from(word);
  return chars.length >= 3 && chars.length <= 14 && chars.every((ch) => TR_ALPHABET.includes(ch));
});
